import React from "react";
import {
  Box,
  useTheme,
  Text,
  Button,
  Flex,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { Theme } from "../../theme";
import { useNavigate } from "react-router-dom";
import getAxios from "../../hooks/useAxios";
import Cookies from "js-cookie";
import { FaArrowRight } from "react-icons/fa";
import Input from "../../components/CustomInput";

const CreateAdmin = () => {
  const theme = useTheme<Theme>();
  const navigate = useNavigate();

  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");

  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [createStatus, setCreateStatus] = React.useState("");

  const createAdmin = async (e: React.BaseSyntheticEvent) => {
    e.preventDefault();
    const data = {
      mobile: phone,
      name: name,
    };
    try {
      const res = await axios.post(`/auth/users`, data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setCreateStatus("created");
      console.log("submit", res);
      setTimeout(() => {
        navigate("/admin");
      }, 2000);
    } catch (error) {
      console.log(error);
      setCreateStatus("error");
    }
  };

  return (
    <Box style={{ padding: "2rem" }}>
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading2,
          marginBottom: theme.space["3xl"],
        }}
      >
        Create Admin
      </Text>
      <Box
        style={{
          width: "50%",
          backgroundColor: "#FFFFFF",
          padding: "2rem",
          borderRadius: "8px",
        }}
      >
        <form onSubmit={createAdmin}>
          <Flex flexDirection={"column"}>
            <label>Administrator Name:</label>
            <Input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              name="name"
              placeholder="Admin name"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Administrator Phone Number:
            </label>
            <Input
              type="number"
              value={phone}
              maxLength={10}
              onChange={(e) => setPhone(e.target.value)}
              name="phone"
              placeholder="Admin phone"
              variant={"outline"}
            />

            <Box sx={{ marginTop: theme.space.xxl }}>
              <Button
                type="submit"
                width="100%"
                height="3rem"
                rightIcon={<FaArrowRight />}
                // isLoading={isLoginLoading ? true : false}
                style={{
                  background: theme.colors.primary.main,
                  color: theme.colors.bg.main,
                }}
              >
                <Text sx={{ fontSize: theme.fontSizes.body }}>Create</Text>
              </Button>
            </Box>

            <Box sx={{ minHeight: "3.25rem" }}>
              {createStatus === "created" && (
                <Alert status="success">
                  <AlertIcon />
                  Admin Created successfully.
                </Alert>
              )}
              {createStatus === "error" && (
                <Alert status="error" borderRadius={"4px"}>
                  <AlertIcon />
                  Opps! Something went wrong.
                </Alert>
              )}
            </Box>
          </Flex>
        </form>
      </Box>
    </Box>
  );
};

export default CreateAdmin;
